<template>
    <div class="t-modal js-modal" :class="{_lk: $route.path.includes('/lk')}">
        <div class="t-modal__container" :class="{_container: modalProps && modalProps.overflowNone}">
            <template v-if="modalProps && !modalProps.hiddenCloseBtn">
              <div
                v-if="!isMobile || ((modalProps && modalProps.closeBthNone === undefined) || modalProps === undefined)"
                class="t-modal__close"
                @click="modalClose"
              >
                <svg v-if="$route.path.includes('/lk')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.5656 5.43451C18.8781 5.74693 18.8781 6.25346 18.5656 6.56588L6.56564 18.5659C6.25322 18.8783 5.74669 18.8783 5.43427 18.5659C5.12185 18.2535 5.12185 17.7469 5.43427 17.4345L17.4343 5.43451C17.7467 5.12209 18.2532 5.12209 18.5656 5.43451Z" fill="#C0C0CC"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.43427 5.43451C5.74669 5.12209 6.25322 5.12209 6.56564 5.43451L18.5656 17.4345C18.8781 17.7469 18.8781 18.2535 18.5656 18.5659C18.2532 18.8783 17.7467 18.8783 17.4343 18.5659L5.43427 6.56588C5.12185 6.25346 5.12185 5.74693 5.43427 5.43451Z" fill="#C0C0CC"/>
                </svg>
                <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="19.4238" y="2.4541" width="3" height="24" transform="rotate(45 19.4238 2.4541)" fill="#929292"/>
                  <rect x="21.5449" y="19.4248" width="3" height="24" transform="rotate(135 21.5449 19.4248)" fill="#929292"/>
                </svg>
              </div>
            </template>
            <div class="t-modal__content">
                <component v-bind:is="modalType" :key="modalType" :props="modalProps" @modal:close="modalClose"></component>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import {mapActions} from 'vuex';

    import regEvent from './modals/regEvent';
    import success from './modals/success';
    import error from './modals/error';
    import noFormat from './modals/noFormat';
    import reviews from './modals/reviews';
    import eventsVideo from './modals/eventsVideo';
    import certificates from './modals/certificates';
    import contacts from './modals/contacts';
    import collab from './modals/collab';
    import fullVersion from './modals/full-version';
    import request from './modals/request';
    import addStaff from './modals/addStaff';
    import deleteStaff from './modals/deleteStaff';
    import editStaff from './modals/editStaff';
    import invite from './modals/invite';
    import inviteSuccess from './modals/lk-success-invite';
    import lkFilter from './modals/lk-filter';
    import competencies from './modals/competencies';
    import training from './modals/training';
    import lkSuccess from './modals/lk-success';
    import lkError from './modals/lk-error';
    import refuseLead from './modals/refuse-lead';
    import attachContact from './modals/attach-contact';
    import changeDate from './modals/change-date';
    import deleteContact from './modals/delete-contact';
    import lkReview from './modals/lk-review';
    import requestContact from './modals/request-contact';
    import lkMobileNotify from './modals/lk-mobile-notify';
    import lkMobileCalendar from './modals/lk-mobile-calendar';
    import actRequest from './modals/act-request';
    import missingData from './modals/missing-data';
    import myOrganisationCompetencies from './modals/my-organisation-competencies.vue';
    import acceptLeadModal from './modals/accept-lead-modal';
    import howWorkWithLeads from './modals/how-work-with-leads.vue'
    import winLeadModal from './modals/win-lead-modal';

    export default {
        components: {
            regEvent,
            success,
            error,
            noFormat,
            reviews,
            eventsVideo,
            certificates,
            contacts,
            collab,
            fullVersion,
            request,
            addStaff,
            deleteStaff,
            editStaff,
            invite,
            lkFilter,
            competencies,
            training,
            lkSuccess,
            lkError,
            refuseLead,
            attachContact,
            changeDate,
            deleteContact,
            lkReview,
            inviteSuccess,
            requestContact,
            lkMobileNotify,
            lkMobileCalendar,
            actRequest,
            missingData,
            myOrganisationCompetencies,
            acceptLeadModal,
            howWorkWithLeads,
            winLeadModal,
        },
        computed: {
            ...mapState('mobile', ['isMobile', 'isTablet']),
            ...mapGetters('modal', ['modalType', 'modalProps']),
        },
        methods: {
            ...mapActions('modal', ['modalClose']),
            close(e) {
                if (e.target.classList.contains('js-modal')) {
                    this.modalClose();
                }
            },
        },
        mounted() {
            document.addEventListener('click', this.close);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.close);
        }
    }
</script>

<style lang="sass">
    @import "~@src/sass/params"

    .t-modal
        position: fixed
        top: 0
        left: 0
        width: 100%
        height: 100vh
        z-index: 20
        display: flex
        justify-content: center
        align-items: center
        background-color: rgba($dark-blue, .55)
        &__container
            padding: 48px 60px 64px
            position: relative
            background-color: #fff
            max-height: 100vh
            border-radius: 6px
            overflow-y: auto
            overflow-x: hidden
            &._container
                overflow: unset
                overflow-y: unset
        &__close
            position: absolute
            right: 60px
            top: 58px
            cursor: pointer
            z-index: 1
            svg
                display: block
            rect, path
                transition: all .2s
            &:hover rect, &:hover path
                fill: $dark-blue

        &._lk
            .t-modal__container
                padding: 32px
            .t-modal__close
                top: 38px
                right: 32px

        @media screen and (min-width: $desktop-medium)
            &._lk
                .t-modal__container
                    padding: 40px
                .t-modal__close
                    top: 46px
                    right: 40px

        @media screen and (min-width: $desktop-big)
            &._lk
                .t-modal__container
                    padding: 40px 48px
                .t-modal__close
                    right: 48px

        @media screen and (max-width: $tablet-size)
            &._lk
                .t-modal__container
                    padding: 24px
                .t-modal__close
                    top: 27px
                    right: 24px

        @media screen and (max-width: $mobile-size)
            &._lk
                .t-modal__container
                    padding: 24px 6px 64px
                    margin: auto 10px 0
                    width: 100%
                    overflow: hidden
                    overflow-y: auto
                .t-modal__close
                    right: 16px
            &__container
                padding: 22px 14px 54px
                margin: 10px 
                max-height: 97vh
            &__close
                right: 24px
                top: 32px

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modal.vue